module.exports = __webpack_public_path__ + "static/media/shift-right.8fcaadc4.svg";